<template>
  <div :class="['wrap', { 'wrap--allow-scroll': allowVerticalScroll }]">
    <slot name="content" />

    <RouterLink
      v-if="showPolicyButton"
      class="policy-button"
      to="/policy"
      title="Политика конфиденциальности"
      aria-label="Политика конфиденциальности"
    >
      <PolicyIcon class="policy-button__icon" />
    </RouterLink>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { isTelegramSession } from "@/shared/lib/telegram/runtime";
import PolicyIcon from "@/assets/icons/policy.svg";

const route = useRoute();

const showPolicyButton = computed(() => {
  const isHomeRoute = route.name === "home";
  return !isTelegramSession() && isHomeRoute;
});

const allowVerticalScroll = computed(() => {
  return route.name === "setup" || route.name === "setup-detail";
});
</script>

<style lang="scss">
.wrap {
  background: $secondary-gradient;
  max-width: 100%;
  width: 100%;
  padding: 20px;
  height: var(--tg-viewport-height, var(--app-viewport-height, 100dvh));
  margin: 0 auto;
  color: $neutral-100;
  position: relative;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  // Учитываем безопасную область Telegram/OS, чтобы контент не уходил под нижнюю панель
  padding-bottom: calc(
    20px + var(--tg-safe-area-inset-bottom, 0px) +
      env(safe-area-inset-bottom, 0px)
  );
}

.wrap--allow-scroll {
  overflow-y: auto;
}

.policy-button {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  color: #333;
  z-index: 1000;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 1);
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: scale(0.95);
  }
}

.policy-button__icon {
  width: 24px;
  height: 24px;
}
</style>
